import axios from "axios";
import {Base_URL} from "../url"

export const fetchTaxCodes = async () => {
  try {
    const response = await axios.get(`${Base_URL}/TaxCodesLogistics/GetAllTaxCodes`);
    console.log(response)
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching tax codes!";
  }
};

export const downloadTaxCodesExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/TaxCodesLogistics/DownloadTaxCodesExcel`,
      null, // Empty body since it's a POST request without payload
      {
        responseType: 'blob' // Important for file downloads
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading tax codes!";
  }
};